<article
    class="product-card"
    [class.order-limit-reached]="vm().orderLimitReached"
    [class.out-of-stock]="vm().isOutOfStock"
>
    <div class="product-image">
        @if (!vm().product.images) {
            <div class="skeleton-wrapper">
                <ng-container *ngTemplateOutlet="skeletonService.rectangleTemplate()"></ng-container>
            </div>
        } @else {
            <div
                class="carousel-wrapper"
                #lightCarousel
                [attr.aria-label]="vm().product.isPromo ? vm().product.name + ' SALE' : vm().product.name"
                (libAccessibleClick)="clickOnProduct.emit(this.vm().product)"
            >
                <lib-light-carousel
                    [images]="vm().smallImagesForCards"
                    [isShiftedDownControls]="true"
                    [label]="product()?.name"
                ></lib-light-carousel>
            </div>
        }
    </div>
    <div class="product-carousel-wrapper">
        <div class="product-carousel">
            <button class="product-carousel__item" type="button"></button>
        </div>
    </div>

    @if (vm().product.isPromo) {
        <p class="product-sale body-0">SALE</p>
    }

    <div class="product-card-content">
        <div
            class="product-details"
            [attr.aria-label]="vm().product.name"
            (click)="clickOnProduct.emit(this.vm().product)"
        >
            <div class="product-details__main">
                @if (isDisplayBrandNameLabel) {
                    <p class="label uppercase">
                        {{ vm().product.brandName }}
                    </p>
                }
                <h3 class="product-title h1">
                    {{ vm().product.name }}
                </h3>
            </div>
            @if (!vm().isOutOfStock) {
                <div class="price">
                    <!-- Prices are loaded in Shopping Dollars; shown as whole numbers, no US dollar equivalent. -->
                    <div class="price__row">
                        @if (vm().discountedPrice) {
                            <p class="primary-cta">{{ vm().discountedPrice | appDigitsGrouping }} {{ rewardName() }}</p>
                            <p class="body-0 price--sale">
                                {{ vm().product.price | appDigitsGrouping }} {{ rewardName() }}
                            </p>
                        } @else {
                            <p class="primary-cta">{{ vm().price | appDigitsGrouping }} {{ rewardName() }}</p>
                        }
                    </div>
                </div>
            }
        </div>
    </div>

    <div class="product-card-actions" [class.is-out-of-stock]="vm().isOutOfStock">
        @if (isMobile()) {
            <button
                class="product-card__action pointer product-card__action--mob"
                [class.disabled]="vm().isOutOfStock || vm().orderLimitReached"
                matTooltipPosition="above"
                type="button"
                [ariaLabel]="ariaLabelAddToCart()"
                [disabled]="vm().isOutOfStock || vm().orderLimitReached"
                [matTooltip]="orderLimitMessage()"
                [matTooltipDisabled]="!vm().orderLimitReached"
                (click)="addToCart.emit(this.vm().product!)"
            >
                <mat-icon svgIcon="ico_cart"></mat-icon>
            </button>
        } @else {
            <button
                mat-button
                class="product-card__action"
                [class.disabled]="vm().isOutOfStock || vm().orderLimitReached"
                color="primary"
                matTooltipPosition="above"
                [ariaLabel]="ariaLabelAddToCart()"
                [disabled]="vm().isOutOfStock || vm().orderLimitReached"
                [matTooltip]="orderLimitMessage()"
                [matTooltipDisabled]="!vm().orderLimitReached"
                (click)="addToCart.emit(this.vm().product!)"
                (pointerenter)="hoverOnAction.emit(true)"
                (pointerleave)="hoverOnAction.emit(false)"
            >
                Add to cart
            </button>
        }
        <!-- RCP-441: wishlist disabled
        <div
            class="pointer wishlist-action"
            (pointerenter)="hoverOnAction.emit(true)"
            (pointerleave)="hoverOnAction.emit(false)"
        >
            <mat-icon
                [attr.aria-hidden]="false"
                [attr.aria-label]="(isInWishList() ? 'Remove from' : 'Add to') + ' wishlist ' + vm().product.name"
                [svgIcon]="isInWishList() ? 'ico_heart_filled' : 'ico_heart'"
                (libAccessibleClick)="toggleWishList()"
            ></mat-icon>
        </div>
        -->
    </div>

    @if (vm().isOutOfStock) {
        <div class="product-card-actions product-card__out-of-stock breadcrumb">
            <span class="product-card__out-of-stock__circle"></span>
            <span class="product-card__out-of-stock__text">This item is no longer available.</span>
        </div>
    } @else if (vm().orderLimitReached) {
        <div class="product-card-actions product-card__order-limit body-2" role="alert">
            <mat-icon class="product-card__order-limit__icon" svgIcon="ico_vector"></mat-icon>
            <span class="product-card__order-limit__text">{{ orderLimitMessage() }}</span>
        </div>
    }
</article>
